module.exports = __webpack_public_path__ + "img/RORBPJR40011.497d8d19.png";